import { Link } from 'react-router-dom';
import { Leaf } from '@phosphor-icons/react';

import { ProfileAvatarLink } from './ProfileAvatarLink';
import pt from '../../locales/pt';
import { paths } from '../../routes/paths';

/**
 * `ds/nav/top-bar--mobile--brand` — modo "logo" do topo mobile (só no Início):
 * altura 56, superfície de card, borda inferior, marca à esquerda e avatar à
 * direita (gap $space-3, padding [0, $space-4]).
 */
export function TopBar() {
  return (
    <header className="fixed inset-x-0 top-0 z-30 flex h-14 items-center justify-between gap-space-3 border-b border-border bg-card px-space-4">
      <Link
        to={paths.dashboard}
        className="flex min-w-0 items-center gap-space-2-5"
      >
        {/* eslint-disable-next-line no-restricted-syntax -- sombra do .pen (offset/blur) com token de cor */}
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-ds-md bg-gradient-to-br from-sage-500 to-sage-600 text-sage-50 shadow-[0_4px_12px] shadow-sage-glow">
          {/* eslint-disable-next-line no-restricted-syntax -- ícone 18×18 do .pen, sem token */}
          <Leaf className="h-[18px] w-[18px]" aria-hidden />
        </span>
        <span className="truncate font-display text-type-title-card font-semibold tracking-tight text-foreground">
          {pt.app.name}
        </span>
      </Link>
      <ProfileAvatarLink />
    </header>
  );
}
